/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SessionResponse } from './sessionResponse';

export interface OrgSessionUser {
  user_id: string;
  email: string;
  first_name: string;
  last_name: string;
  avatar_url?: string | null;
  role: string;
  session_count: number;
  sessions: SessionResponse[];
}
